import React from "react";
import line from "../assets/line.png";
import First from "../assets/First.jpg";
import Med1 from "../assets/Med1.png";
import Med2 from "../assets/Med2.png";
import ColourLogo from "../assets/ColourLogo.svg";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";


const Medical = () => {
  return (
    <div className="min-h-screen scroll-smooth">
      {/* Hero Section with Video Background for Services */}
     {/* Hero Section with Video Background for Services */}
<section className="relative h-[60vh] flex items-center justify-center text-white overflow-hidden">
  {/* 🎥 Background Video */}
  <video
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
    src="/Services780.mp4"
    autoPlay
    muted
    loop
    playsInline
  />

  {/* 💜 Overlay */}
  <div className="absolute inset-0 bg-gradient-to-r from-[#0A1B60] via-[#1F2E8A] to-[#4B0FA3] opacity-40 z-10" />

  {/* 📝 Foreground Content */}
  <div className="relative z-20 flex flex-col items-center text-center px-4">
    
    {/* Main Heading */}
    <h1
      className="
        font-extrabold text-white uppercase
        text-3xl sm:text-5xl md:text-6xl lg:text-7xl
      "
      style={{
        fontFamily: "Calibri, sans-serif",
        letterSpacing: "0.04em",
      }}
    >
      MEDICAL CODING
    </h1>

    {/* Sub Heading */}
    <h2
      className="
    uppercase font-extrabold mt-4
    text-white [@media(hover:hover)]:text-transparent
  "
  style={{
    fontFamily: "Calibri, sans-serif",
    WebkitTextStroke: "2px #ffffff",
    fontSize: "3rem",
    lineHeight: "1.1",
    letterSpacing: "0.05em",
  }}
>
      Accurate. Compliant. Efficient
    </h2>

  </div>
</section>


      {/* Vision Section */}
      <section className="pt-12 sm:pt-20 pb-8 sm:pb-12 px-4 sm:px-6 bg-white flex flex-col items-center justify-center text-center w-full !h-auto">
       <div className="max-w-6xl w-full mx-auto flex flex-col items-center text-gray-900 text-sm sm:text-base md:text-lg lg:text-xl font-normal leading-relaxed space-y-6 sm:space-y-10">
        <p
  className="max-w-4xl text-center px-2 sm:px-4 text-[26px]"
  style={{ lineHeight: "1.5" }}
>
  At Wissenstil, our Medical Coding services are driven by precision and compliance. By combining domain expertise with AI-powered tools, we ensure accurate classification of diagnoses, procedures, and treatments in alignment with global healthcare standards like ICD and CPT. Whether for hospitals, clinics, or billing partners, our streamlined coding process enhances claim success rates and reduces administrative burdens.
</p>


</div>

      </section>

      {/* Services Section */}
      <section className="pt-12 sm:pt-20 pb-8 sm:pb-12 px-4 sm:px-6 bg-white flex flex-col items-center justify-center w-full !h-auto">
        <div className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Left Side - Heading + Image */}
          <div className="flex flex-col items-center md:items-start space-y-4 sm:space-y-16 text-center md:text-left">
            <div className="relative inline-block ml-10 md:translate-x-4 lg:translate-x-0">


              <h2 className="text-black text-2xl sm:text-3xl md:text-4xl font-semibold">
                Code <span style={{ color: "#0077cc" }}>Services</span>
              </h2>
              <img
                src={line}
                alt="underline"
                className="absolute left-0 -bottom-2 h-[6px] object-contain"
              />
            </div>
            <img
              src={Med1}
              alt="Medical Coding illustration"
              className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
            />
          </div>

          {/* Right Side - Paragraph */}
          <div className="flex items-center">
           <p
  className="text-gray-700 text-sm sm:text-base md:text-[26px] text-justify"
  style={{ lineHeight: "1.5" }}
>
  <span className="font-bold text-gray-900">Medical Coding</span> <br />
  Expert coding across specialties including cardiology, pathology,
  radiology, pediatrics, oncology, and more. Our team is well-versed in
  CPT, ICD-10, and HCPCS, adhering to industry standards like CCI and
  LMRPs.
  <br />
  <br />
  <span className="font-bold text-gray-900">Charge Entry &amp; Payment Posting</span> <br />
  Streamlined charge capture and real-time posting of insurance and
  personal receipts, ensuring faster reimbursement cycles.
</p>


          </div>
        </div>
      </section>

      {/* AR + Insurance */}
<section className="py-10 sm:py-12 px-4 sm:px-6 bg-white flex flex-col items-center justify-center w-full !h-auto">
  <div className="max-w-4xl w-full">
    <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-[26px] text-justify" style={{ lineHeight: "1.5" }}>
      <span className="font-bold text-gray-900 block mb-1">
        Accounts Receivable (AR) Management
      </span>
      Detailed analysis and follow-up on aging AR, with focus on denial
      management, underpayments, and clean-up of old accounts.
      <br />
      <br />
      <span className="font-bold text-gray-900 block mb-1">
        Insurance Verification &amp; Follow-Up
      </span>
      Proactive checks and communication to prevent claim rejections and
      accelerate approvals.
      <br />
      <br />
      <span className="font-bold text-gray-900 block mb-1">
        Audit &amp; Compliance
      </span>
      Comprehensive audits and internal checks to ensure quality, accuracy,
      and policy adherence at every step.
    </p>
  </div>
</section>


      {/* Specialized Services Section */}
      <section className="pt-12 sm:pt-20 pb-8 sm:pb-12 px-4 sm:px-6 bg-white flex flex-col items-center justify-center w-full !h-auto">
        <div className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div className="flex flex-col items-center md:items-start space-y-4 sm:space-y-6 text-center md:text-left">
            <div className="relative inline-block ml-10 md:translate-x-4 lg:translate-x-0">
              <h2 className="text-black text-2xl sm:text-3xl md:text-4xl font-semibold">
                Specialized <span style={{ color: "#0077cc" }}>Services</span>
              </h2>
              <img
                src={line}
                alt="underline"
                className="absolute left-0 -bottom-2 h-[6px] object-contain"
              />
            </div>
            <img
              src={Med2}
              alt="Medical Coding illustration"
              className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
            />
          </div>

          <div className="flex items-center">
           <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-[26px] text-justify" style={{ lineHeight: "1.5" }}>
  <span className="font-bold text-gray-900">
    HCC Coding &amp; HEDIS Abstraction
  </span>
  <br />
  We offer risk adjustment services for Medicare Advantage plans using
  HCC coding protocols. Our HEDIS abstraction services further enhance
  plan performance and compliance.
  <br />
  <br />
  <span className="font-bold text-gray-900">AR Calling</span>
  <br />
  Professional AR callers handle insurance follow-ups, denial
  resolution, and payment discrepancies to improve cash flow.
</p>

          </div>
        </div>
      </section>

      {/* Provider Enrollment */}
      <section className="py-10 sm:py-12 px-4 sm:px-6 bg-white flex flex-col items-center justify-center w-full !h-auto">
        <div className="max-w-4xl w-full">
            <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-[26px] text-justify" style={{ lineHeight: "1.5" }}>
            <span className="font-bold text-gray-900 block mb-1">
              Provider Enrollment &amp; Credentialing
            </span>
            Efficient management of provider documentation and submission for faster
            credentialing and reimbursements.
          </p>
        </div>
      </section>

     {/* Training Section */}
<section className="py-10 sm:py-12 px-4 sm:px-6 bg-white w-full !h-auto">
  <div className="max-w-4xl w-full mx-auto text-left">
    <div className="relative inline-block mb-6">
      <h2 className="text-black text-xl sm:text-2xl md:text-3xl font-semibold">
        Training &amp; Upskilling
      </h2>
      <img
        src={line}
        alt="underline"
        className="absolute left-0 -bottom-2 h-[6px] object-contain"
      />
    </div>

     <p className="text-gray-700 leading-relaxed text-sm sm:text-base md:text-[26px] text-justify" style={{ lineHeight: "1.5" }}>
      We run industry-focused certification training programs in Medical
      Coding, HCC, and Medical Billing, designed for both fresh talent and
      working professionals. Our trainers, certified by AAPC and AHIMA, have
      extensive real-world experience and a proven track record of exam
      success.
    </p>
    <ul className="list-disc list-inside text-gray-700 leading-relaxed text-sm sm:text-base md:text-[26px] space-y-4 text-justify mt-6">
      <li>Diploma in Medical Coding</li>
      <li>Training for CPC, CPC-H, CCS &amp; CCA</li>
      <li>Hands-on coding workshops using industry software</li>
      <li>ICD-10-CM &amp; PCS curriculum</li>
    </ul>
  </div>
</section>

      {/* Why Choose Us */}
<section className="bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white w-full py-12 sm:py-20 h-auto flex items-center justify-center">
  

        <div className="max-w-6xl w-full px-4 sm:px-6 translate-x-2 md:translate-x-8">

         <div
  className="relative inline-block"
  style={{ transform: "translateX(8px)" }}
>
  <h2 className="text-white text-2xl sm:text-3xl md:text-4xl font-semibold">
    Why <span style={{ color: '#0077cc' }}>Choose Us</span>
  </h2>
  <img
    src={line}
    alt="underline"
    className="absolute left-0 -bottom-2 h-[6px] w-full object-contain"
  />
</div>








          <div className="mt-8 sm:mt-10 w-full flex justify-center">
 <div className="grid grid-cols-1 md:grid-cols-2 gap-x-40 gap-y-6 justify-center">
  {/* Left Column */}
  <ul className="space-y-4 sm:space-y-6 list-disc list-inside marker:text-blue-400 text-base sm:text-lg md:text-[26px] leading-relaxed">
    {['Certified Expertise', 'End-to-End RCM Support', 'HIPAA & HITECH Compliant'].map(
      (item, index) => (
        <li
          key={index}
          className="font-medium transition-transform duration-300 hover:translate-x-2"
        >
          {item}
        </li>
      )
    )}
  </ul>

  {/* Right Column — move slightly left only in mobile */}
  <ul className="-translate-x-4 md:translate-x-0 space-y-4 sm:space-y-6 list-disc list-inside marker:text-blue-400 text-base sm:text-lg md:text-[26px] leading-relaxed">
    {[
      'Client-Centric Adaptability',
      'Continuous Staff Training',
      'Faster Reimbursements',
    ].map((item, index) => (
      <li
        key={index}
        className="font-medium transition-transform duration-300 hover:translate-x-2"
      >
        {item}
      </li>
    ))}
  </ul>
</div>





</div>

        </div>
      </section>
 <section className="relative bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F] overflow-hidden h-auto">
  {/* White curved part */}
  <div className="absolute top-[180px] left-0 w-full">
  <div className="
    bg-white 
    rounded-t-[12rem] 
    sm:rounded-t-[14rem] 
    h-auto 
    sm:h-[120vh]
    pb-10
  "></div>
</div>
  {/* Content */}
  <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-24 pb-16">
    {/* Top heading part */}
    <div className="text-center mt-[160px] mb-12">
     <h2
  className="text-4xl sm:text-5xl font-bold mb-2 text-[#6F7DFF]"
>
  Collaborate for Success
</h2>
      <p className="text-gray-700 text-lg sm:text-xl font-medium">
        Working together with others fosters innovation, creativity, and a greater sense of accomplishment.
      </p>
    </div>

    {/* Four-column footer part */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">
      {/* About Us */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
        <img src={ColourLogo} alt="Wissenstil Solutions" className="w-40 mb-4" />
      <p className="mb-4 leading-relaxed">
  Wissenstil Solutions is a specialized software company driving digital innovation.
</p>
      </div>

      {/* Services */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
        <ul className="space-y-2">
          <li>Image Analysis</li>
          <li>Anomaly Detection</li>
          <li>Medical Coding</li>
        </ul>
      </div>

  
{/* Useful Links */}
<div>
  <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
  <ul
    className="space-y-2 text-gray-800"
    style={{ fontFamily: 'Calibri, sans-serif' }}
  >
    {[
      { name: "About Us", path: "/about" },
      { name: "Wise Services", path: "/services" },
      { name: "Wise Products", path: "/products" },
      { name: "Contact Us", path: "/contact" },
    ].map((link, index) => (
      <li
        key={index}
        className="transition-transform duration-300 hover:translate-x-2 text-base sm:text-lg md:text-xl"
      >
        <Link
          to={link.path}
          onClick={() => (window.location.href = link.path)}
          className="relative inline-block hover:text-purple-700 transition-colors duration-200 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-purple-700 hover:after:w-full after:transition-all after:duration-300"
        >
          {link.name}
        </Link>
      </li>
    ))}
  </ul>
</div>

      {/* Contact */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">CONTACT US</h3>
        <p>
          Wissenstil Solutions Private Ltd.<br />
          Brigade IRV Centre, 09th &amp; 10th Floor,<br />
          Nallurahalli, Whitefield,<br />
          Bangalore, 560066.
        </p>
     

<div className="mt-4 space-y-3 text-white">
  <p className="flex items-center space-x-3">
    <Phone className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">+91 9986158307</span>
  </p>
  <p className="flex items-center space-x-3">
    <Mail className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">Manish.palliyil@wissenstil.com</span>
  </p>
</div>
      </div>
    </div>
  </div>
</section>


    </div>
  );
};

export default Medical;